import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import * as FaIcons from "react-icons/fa";
import "../../scss/pages/admin/_leloregistration.scss";
import phoneTypes from "../../data/phoneTypes";
import leloContext from "../../context/leloreg/leloContext";
import { toast } from "react-toastify";

const R2StudentInformation = () => {
  const LeloContext = useContext(leloContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [FormSubmit, setFormSubmit] = useState(false);
  const [birth, setBirth] = useState(false);
  const { _uuid, _id, LeloRegistrationProfile, permalink } = location.state || {};
  const {
    formData: {
      hasPreviouslyEnrolled,
      firstName,
      middleName,
      lastName,
      gender,
      birthDate,
      studentEmail,
      studentPrimaryPhone,
      studentPrimaryPhoneType,
      ages,
      charter,
      charter_id,
    },
    age,
    getAge,
    onFormDataChange,
    pass: { student },
    leloDatauuid,
    getLeloDataUuid,
  } = LeloContext;
  // useEffect(() => {
  //   if (!charter_id) {
  //     alert("Something went wrong");
     
  //     if (_uuid === undefined) {
  //       history.push(`/forms/${permalink}/${_id}`);
  //     } else {
  //       history.push(`/forms/${permalink}/${_uuid}/${LeloRegistrationProfile}`);
  //     }
  //   }
  // }, [charter_id, history, permalink, LeloRegistrationProfile, _id, _uuid]);

  useEffect(() => {
    if (!charter_id) {
      toast.error("Something went wrong");
      if (_uuid === undefined) {
        navigate(`/forms/${permalink}`);
      } else {
        navigate(`/forms/${permalink}/${_uuid}`);
      }
    }
  }, [charter_id, navigate, permalink, LeloRegistrationProfile, _id, _uuid]);
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);  

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "firstName" || name === "middleName" || name === "lastName") {
      onFormDataChange({
        target: {
          name,
          value: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
        },
      });
    } else {
      onFormDataChange(e);
    }
  };

  const calculateAge = (birthDate) => {
    const birthDateObj = new Date(birthDate);
    if (isNaN(birthDateObj)) {
      console.error("Invalid birthDate:", birthDate);
      return 0; 
    }
    const today = new Date();
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDifference = today.getMonth() - birthDateObj.getMonth();
  
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDateObj.getDate())) {
      age--;
    }
  
    return age;
  };
  
  useEffect(()=>{
    if(_uuid){
      getLeloDataUuid(_uuid)
    }   
  },[_uuid])

  useEffect(() => {
    if (leloDatauuid?.data) {
      const site = leloDatauuid.data;
      
      if (site) {
        const { firstName, lastName, birthDate, studentEmail, studentPrimaryPhone } = site;
  
        // Update formData
        onFormDataChange({
          target: { name: "firstName", value: firstName || "" }, });
        onFormDataChange({
          target: { name: "lastName", value: lastName || "" }, });

        if (studentEmail && studentEmail.trim() !== "") {
          onFormDataChange({ target: { name: "studentEmail", value: studentEmail } });
        }
        if(studentPrimaryPhone && studentPrimaryPhone.trim() !== ""){
          onFormDataChange({ target: { name: "studentPrimaryPhone", value: studentPrimaryPhone } });
        }
        if(birthDate && birthDate.trim() !== ""){
          onFormDataChange({ target: { name: "birthDate", value: birthDate } });
        }
        
        if (birthDate) {
          const calculatedAge = calculateAge(birthDate);
          onFormDataChange({ target: { name: "ages", value: calculatedAge }, });
        }
      }
    }
  }, [ leloDatauuid]);

  const formatPhoneNumber = (e) => {
    let formattedValue = e.target.value.replace(/\D/g, "");
    if (formattedValue.length > 6) {
      formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(
        3,
        6
      )}-${formattedValue.slice(6)}`;
    } else if (formattedValue.length > 3) {
      formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(
        3
      )}`;
    }
    onFormDataChange({
      target: { name: "studentPrimaryPhone", value: formattedValue },
    });
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (number) =>
   /^\d{3}-\d{3}-\d{4}$/.test(number);

  const validateBirthday = (date) => {
    return date && moment(date, "YYYY-MM-DD", true).isValid();
  };

  const studentFilledOut =
    hasPreviouslyEnrolled &&
    firstName &&
    lastName &&
    gender &&
    birthDate &&
    studentEmail &&
    studentPrimaryPhone &&
    studentPrimaryPhoneType &&
    validateEmail(studentEmail) &&
    validatePhone(studentPrimaryPhone);

  const handleSubmit = () => {
    setFormSubmit(true);
    if(_uuid === undefined){
      if (studentFilledOut && age >= 1 && age <= 100) {
        navigate("/leloStudent1", { state: { permalink, _uuid, age,  _id, LeloRegistrationProfile } });
      } else if (age < 1 || age > 100) {
        setBirth(true)
      }
    }else{
      if (studentFilledOut && ages >= 1 && ages <= 100) {
        navigate("/leloStudent1", { state: { permalink, _uuid, ages, _id, LeloRegistrationProfile } });
      } else if (ages < 1 || ages > 100) {
        setBirth(true)
      }
    }
  };

  // Helper function to get CSS class for form validation
  const getInputClassName = (value, isDate = false) => {
    if (FormSubmit && (!value || (isDate && !validateBirthday(value)))) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  // Helper function for optional fields
  const getOptionalInputClassName = () => "form-field-optional";

  if (_uuid === undefined) {
    return (
      <div className="sub-form">
        <h2>
          Student Information <span>(2/7)</span>
          <hr />
        </h2>

        {/* Previously Enrolled */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName} Previously
              Enrolled in our School or Another Program Before ?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="hasPreviouslyEnrolled"
            value={hasPreviouslyEnrolled}
            onChange={handleChange}
            className={getInputClassName(hasPreviouslyEnrolled)}>
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            <option value="Unsure">Unsure</option>
          </select>
        </div>

        {/* First Name */}
        <div className="item">
          <div className="asterisk-group">
            <h3>What is the Student's First Name?</h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="firstName"
            maxLength="50"
            value={firstName}
            required
            onChange={handleChange}
            className={getInputClassName(firstName)}
          />
        </div>

        {/* Middle Name (Optional) */}
        <div className="item">
          <h3>
            What is {firstName === "" ? "the Student" : firstName}'s Middle Name?
          </h3>
          <input
            type="text"
            name="middleName"
            maxLength="50"
            value={middleName}
            onChange={handleChange}
            className={getOptionalInputClassName()}
          />
        </div>

        {/* Last Name */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Last Name?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="lastName"
            maxLength="50"
            value={lastName}
            required
            onChange={handleChange}
            className={getInputClassName(lastName)}
          />
        </div>

        {/* Gender */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Gender?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="gender"
            value={gender}
            onChange={handleChange}
            className={getInputClassName(gender)}>
            <option value="">Select</option>
            <option value="Female">Female</option>
            <option value="Male">Male</option>
            <option value="Non-Binary">Non-Binary</option>
          </select>
        </div>

        {/* Birth Date */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Date of Birth?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="date"
            name="birthDate"
            max={moment().format("YYYY-MM-DD")}
            value={birthDate}
            onChange={(e) => {
              onFormDataChange(e);
              getAge(moment(e.target.value).utc());
            }}
            className={getInputClassName(birthDate, true)}
          />
          {FormSubmit && (!birthDate || !validateBirthday(birthDate) || birth) && (
            <p className="validEmail">Please provide a valid date of birth</p>
          )}
          {birthDate && !birth && (
            <p>{`${firstName || "The student"} is ${age} years old? If not, select birth date again`}</p>
          )}
        </div>

        {/* Email */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Personal
              Email Address?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="email"
            name="studentEmail"
            value={studentEmail}
            onChange={handleChange}
            className={getInputClassName(studentEmail)}
          />
          {studentEmail !== "" && !validateEmail(studentEmail) && (
            <p className="validEmail">Please provide a valid email address</p>
          )}
        </div>

        {/* Primary Phone */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Phone
              Number?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            placeholder="XXX-XXX-XXXX"
            name="studentPrimaryPhone"
            value={studentPrimaryPhone}
            maxLength={12}
            onChange={formatPhoneNumber}
            className={getInputClassName(studentPrimaryPhone)}
          />
          {studentPrimaryPhone !== "" && !validatePhone(studentPrimaryPhone) && (
            <p className="validEmail">
              Please provide a valid phone number in the following format
              XXX-XXX-XXXX
            </p>
          )}
        </div>

        {/* Phone Type */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Phone Type?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="studentPrimaryPhoneType"
            value={studentPrimaryPhoneType}
            onChange={handleChange}
            className={getInputClassName(studentPrimaryPhoneType)}>
            <option value="">Select</option>
            {phoneTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Progress Buttons */}
        <div className="progress-btns">
          <div className="circle-btn">
            <FaIcons.FaChevronLeft
              className="progress-level-btn"
              onClick={() => navigate(-1)}
            />
          </div>

          <div className="circle-btn" onClick={handleSubmit}>
            <FaIcons.FaChevronRight
              className="progress-level-btn"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
  else {
    return (
      <div className="sub-form">
        <h2>
          Student Information <span>(2/7)</span>
          <hr />
        </h2>

        {/* Previously Enrolled */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              Has {firstName === "" ? "the Student" : firstName}'s Previously
              Enrolled in our School or Another Learn4Life Program Before ?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="hasPreviouslyEnrolled"
            value={hasPreviouslyEnrolled}
            onChange={handleChange}
            className={getInputClassName(hasPreviouslyEnrolled)}>
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
            <option value="Unsure">Unsure</option>
          </select>
        </div>

        {/* First Name */}
        <div className="item">
          <div className="asterisk-group">
            <h3>What is the Student's First Name?</h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="firstName"
            maxLength="50"
            value={firstName}
            required
            disabled
            onChange={handleChange}
            className={getInputClassName(firstName)}
          />
        </div>

        {/* Middle Name (Optional) */}
        <div className="item">
          <h3>
            What is {firstName === "" ? "the Student" : firstName}'s Middle Name?
          </h3>
          <input
            type="text"
            name="middleName"
            maxLength="50"
            value={middleName}
            onChange={handleChange}
            className={getOptionalInputClassName()}
          />
        </div>

        {/* Last Name */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Last Name?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="lastName"
            maxLength="50"
            value={lastName}
            disabled
            required
            onChange={handleChange}
            className={getInputClassName(lastName)}
          />
        </div>

        {/* Gender */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Gender?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="gender"
            value={gender}
            onChange={handleChange}
            className={getInputClassName(gender)}>
            <option value="">Select</option>
            <option value="Female">Female</option>
            <option value="Male">Male</option>
            <option value="Non-Binary">Non-Binary</option>
          </select>
        </div>

        {/* Birth Date */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Date of Birth?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="date"
            name="birthDate"
            max={moment().format("YYYY-MM-DD")}
            value={birthDate}
            disabled
            onChange={(e) => {
              onFormDataChange(e);
              getAge(moment(e.target.value).utc());
            }}
            className={getInputClassName(birthDate, true)}
          />
          {FormSubmit && (!birthDate || !validateBirthday(birthDate) || birth) && (
            <p className="validEmail">Please provide a valid date of birth</p>
          )}
          {birthDate && !birth && (
            <p>{`${firstName || "The student"} is ${ages} years old? If not, select birth date again`}</p>
          )}
        </div>

        {/* Email */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Personal
              Email Address?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="email"
            name="studentEmail"
            value={studentEmail}
            onChange={handleChange}
            className={getInputClassName(studentEmail)}
          />
          {studentEmail !== "" && !validateEmail(studentEmail) && (
            <p className="validEmail">Please provide a valid email address</p>
          )}
        </div>

        {/* Primary Phone */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Phone
              Number?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            placeholder="XXX-XXX-XXXX"
            name="studentPrimaryPhone"
            value={studentPrimaryPhone}
            maxLength={12}
            onChange={formatPhoneNumber}
            className={getInputClassName(studentPrimaryPhone)}
          />
          {studentPrimaryPhone !== "" && !validatePhone(studentPrimaryPhone) && (
            <p className="validEmail">
              Please provide a valid phone number in the following format
              XXX-XXX-XXXX
            </p>
          )}
        </div>

        {/* Phone Type */}
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Phone Type?
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="studentPrimaryPhoneType"
            value={studentPrimaryPhoneType}
            onChange={handleChange}
            className={getInputClassName(studentPrimaryPhoneType)}>
            <option value="">Select</option>
            {phoneTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Progress Buttons */}
        <div className="progress-btns">
          <div className="circle-btn">
            <FaIcons.FaChevronLeft
              className="progress-level-btn"
              onClick={() => navigate(-1)}
            />
          </div>

          <div className="circle-btn" onClick={handleSubmit}>
            <FaIcons.FaChevronRight
              className="progress-level-btn"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
};

export default R2StudentInformation;